import BaseService from './base';
import request from '@/utils/request';

export interface ChartsViewModel {
  id?: number;
  name?: string;
  loadWith?: boolean;
  isPublic?: number;
}

export interface ChartsNodeViewModel {
  id?: number;
  chartsID?: number;
  timelineItemID?: number;
  name?: string;
  color?: string;
  size?: number;
  dataIndex?: number;
}

export interface ChartsLinkViewModel {
  id?: number;
  chartsID?: number;
  source?: number;
  target?: number;
  name?: string;
  curveness?: number;
  width?: number;
  dataIndex?: number;
}

export class ChartsService extends BaseService<ChartsViewModel> {
  protected serviceApi: string = 'Charts';

  get NewModel(): ChartsViewModel {
    return {
      name: '',
    };
  }
}

export class ChartsNodeService extends BaseService<ChartsNodeViewModel> {
  protected serviceApi: string = 'ChartsNode';

  get NewModel(): ChartsNodeViewModel {
    return {
      name: '',
    };
  }

  public GetByChartsId(id: number) {
    return request({
      url: `${this.serviceApi}/GetBychartsId/${id}`,
      method: 'get',
    });
  }
  public GetTimelineItem(id: number) {
    return request({
      url: `${this.serviceApi}/GetTimelineItem/${id}`,
      method: 'get',
    });
  }
}

export class ChartsLinkService extends BaseService<ChartsLinkViewModel> {
  protected serviceApi: string = 'ChartsLink';

  get NewModel(): ChartsLinkViewModel {
    return {
      name: '',
      // source: 0,
      // target: 0,
    };
  }

  public GetByChartsId(id: number) {
    return request({
      url: `${this.serviceApi}/GetBychartsId/${id}`,
      method: 'get',
    });
  }
}
